import { Controller } from "@hotwired/stimulus"
import { showAlert } from "../lib/alerts"

export default class extends Controller {
  static targets = ["dialog", "textarea"]
  static values = { listUrl: String, entryId: Number }

  open(event) {
    event.preventDefault()
    this.dialogTarget.showModal()
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) {
      this.dialogTarget.close()
    }
  }

  submit(event) {
    event.preventDefault()
    const text = this.textareaTarget.value
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.listUrlValue + ".json", {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
      },
      body: JSON.stringify({
        list: { list_entries_attributes: { "0": { id: this.entryIdValue, public_note: text } } },
      }),
    }).then((response) => {
      if (response.ok) {
        this.dialogTarget.close()
        showAlert("Note updated")
        Turbo.visit(window.location.href, { action: "replace" })
      } else {
        showAlert("Error saving note")
      }
    })
  }
}
